var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "#1e50a0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "40 28.856 40 32 50.181 32 67 21.691 67 17 59.346 17 40 28.856"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d22f27",
    points: "67 17 67 17 63.173 17 40 31.203 40 32 43.482 32 67 17.586 67 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "59.347 55 67 55 67 55 67 50.308 50.182 40 40 40 40 43.143 59.347 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d22f27",
    points: "67 55 67 52.653 46.355 40 41.568 40 66.042 55 67 55 67 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "32 43.144 32 40 21.819 40 5 50.309 5 55 12.654 55 32 43.144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d22f27",
    points: "5 55 5 55 8.827 55 32 40.797 32 40 28.518 40 5 54.414 5 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "12.653 17 5 17 5 17 5 21.692 21.818 32 32 32 32 28.857 12.653 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d22f27",
    points: "5 17 5 19.347 25.646 32 30.432 32 5.958 17 5 17 5 17"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 31,
    width: 62,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 17,
    width: 10,
    height: 38,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 33,
    width: 62,
    height: 6,
    fill: "#d22f27"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 17,
    width: 6,
    height: 38,
    fill: "#d22f27"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 62,
    height: 38,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.bca4c3c01fafedfd08364e067960c74b.svg";
export { ForwardRef as ReactComponent };